import { FollowOnModelDTO } from '../component/dto/FollowOnModelDTO';
import { ModelForTableDTO } from '../component/dto/ModelForTableDTO';
import { AllocationDTO } from '../component/dto/AllocationDTO';

export interface RiskProbability {
  riskProb: number;
  iconNameAndStylingLeft: string;
}

export interface PerfPredictTvpi {
  current: number;
  predict: number;
  diff: number;
}

export class CommitmentAllocModelInfo {
  all: FollowOnModelDTO[];
  selected: FollowOnModelDTO = new FollowOnModelDTO();
  initial: FollowOnModelDTO;
}

export class ModelDataStatus {
  /** is used to be able to cancel unsaved changes */
  initial: CommitmentAllocModelData = new CommitmentAllocModelData();
  /** is provided to follow-on-model-table component as input */
  forEdit: CommitmentAllocModelData = new CommitmentAllocModelData();
}

export class CommitmentAllocModelData {
  newInvestment: ModelForTableDTO = new ModelForTableDTO();
  active: ModelForTableDTO = new ModelForTableDTO();
  sold: ModelForTableDTO = new ModelForTableDTO();
}

export enum CommitmentAllocModelDataType {
  NEW_INVESTMENT = 'newInvestment',
  ACTIVE = 'active',
  SOLD = 'sold',
}

export class CommitmentAllocationModelAllocation {
  selected: AllocationDTO;
  initial: AllocationDTO;
}
